import  './Home.css';
import {useMediaQuery} from "react-responsive";
import {useEffect, useState} from "react";

const Home = () => {
    const isDesktop = useMediaQuery({ minWidth: 992 });
    const title = 'Agri-Tech Solution Madagascar';
    const [homeImg, setHomeImg] = useState('home.webp');

    useEffect(() => {
        if (isDesktop) {
            setHomeImg("home.webp");
        } else {
            setHomeImg("home-mobile.webp");
        }
    }, [isDesktop]);


    return (
        <>
            <div className={"home"}>
                <img className={"home-img"} src={homeImg} alt={title}/>
                <p className={"title animate"}>{title}</p>
                <p className={"slogan animate"}>Cultivons l'avenir ensemble avec la technologie.</p>
            </div>
        </>
    );
}

export default Home;